export default class Modal {
    static key = 'Modal';
    constructor() {
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);

        this.cacheDom();
        this.init();
    }

    /* -----------------------------------------
     * DOM
     * ----------------------------------------- */
    cacheDom() {
        this.dom = {
            html: document.documentElement,
            panel: document.querySelector('.js-panel'),
            overlay: document.querySelector('.js-panel-overlay'),
            openers: document.querySelectorAll('.js-open-panel'),
            closers: document.querySelectorAll('.js-close-panel'),
        };
    }

    /* -----------------------------------------
     * Init
     * ----------------------------------------- */
    init() {
        if (!this.dom.panel) return;

        this.dom.openers.forEach((btn) => {
            btn.addEventListener('click', this.open);
        });

        this.dom.closers.forEach((btn) => {
            btn.addEventListener('click', this.close);
        });
    }

    /* -----------------------------------------
     * Actions
     * ----------------------------------------- */
    open(e) {
        e.preventDefault();

        this.dom.panel.classList.add('is-active');
        this.dom.overlay.classList.add('is-active');
        this.dom.html.classList.add('has-modal-open');
    }

    close() {
        this.dom.panel.classList.remove('is-active');
        this.dom.overlay.classList.remove('is-active');
        this.dom.html.classList.remove('has-modal-open');
    }
}
